webpackJsonp([196595609522706],{

/***/ 1292:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/polk-county-community-corrections-transitional-housing/"},"frontmatter":{"title":"Polk County Community Corrections Transitional Housing","subTitle":"The capacity of transitional housing was increased to reduce the number of homeless recently-released offenders.","date":"2016-09-29","category":"Correctional"}}}]}},"pathContext":{"posts":[{"title":"Polk County Community Corrections Transitional Housing","slug":"/polk-county-community-corrections-transitional-housing/"}],"tagName":"Housing","tagCount":1}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-housing-3dbe1caf88dd651ef28e.js